"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.storeCoverage = void 0;
/** The 50 US states. DC and territories don't count toward "nationwide". */
const US_STATES = [
    'AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'FL', 'GA', 'HI', 'ID', 'IL', 'IN', 'IA',
    'KS', 'KY', 'LA', 'ME', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ',
    'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT',
    'VA', 'WA', 'WV', 'WI', 'WY',
];
/** Covering this many of the 50 states reads as nationwide. */
const NATIONWIDE_MIN_STATES = 40;
/**
 * Patient-facing coverage line for a storefront. `allowedStates` is the
 * clinic's own licenses ∪ its telemed network's coverage, so telemed clinics
 * whose network reaches 40+ states read as nationwide instead of the clinic's
 * home state. The DTP catalog sends this as `clinic.coverage`.
 */
function storeCoverage(clinic) {
    const covered = new Set((clinic.allowedStates || []).map(s => s.trim().toUpperCase()).filter(Boolean));
    const stateCount = US_STATES.filter(s => covered.has(s)).length;
    if (stateCount >= NATIONWIDE_MIN_STATES)
        return { kind: 'nationwide', label: 'Available nationwide' };
    if (covered.size > 3)
        return { kind: 'multi', label: `Available in ${stateCount} states` };
    if (covered.size > 1)
        return { kind: 'multi', label: `Available in ${Array.from(covered).sort().join(', ')}` };
    const only = covered.size === 1 ? Array.from(covered)[0] : clinic.state;
    return only ? { kind: 'single', label: `Licensed in ${only}` } : null;
}
exports.storeCoverage = storeCoverage;
//# sourceMappingURL=storeCoverage.js.map